import React from 'react';
import { Hero } from '../components/home/Hero';
import { SongMarquee } from '../components/home/SongMarquee';
import { StatsIntro } from '../components/home/StatsIntro';
import { VideoSection } from '../components/home/VideoSection';
import { BandSection } from '../components/home/BandSection';
import { FormulasSection } from '../components/home/FormulasSection';
import { AudienceSection } from '../components/home/AudienceSection';
import { PhotoBreak } from '../components/home/PhotoBreak';
import { BookingCta } from '../components/home/BookingCta';
export function Home() {
  return <>
      <Hero data-id="element-218" data-mp="29fvhxqjhry44" />
      <SongMarquee data-id="element-219" data-mp="29f2bkqog3ami" />
      <StatsIntro data-id="element-220" data-mp="29etusnp7bl61" />
      <VideoSection data-id="element-221" data-mp="29ihphq6dudmc" />
      <BandSection data-id="element-222" data-mp="2dhgsv6cgu2bo" />
      <FormulasSection data-id="element-223" data-mp="2dhyu6hdzj6qg" />
      <AudienceSection data-id="element-224" data-mp="2dja0ooytesl9" />
      <PhotoBreak data-id="element-225" data-mp="2dfm7xs172a7l" />
      <BookingCta data-id="element-226" data-mp="3kvac6mkbgbvj" />
    </>;
}